export const POLICY_CODE = {
  simulation: 'S',
  quotation: 'C',
} as const
